/**
 * Translation for the shadcn primitives here: several are plain functions, not components,
 * so they cannot use the `useTranslation` hook. The English `fallback` covers a render
 * before i18n boots, where `t()` would return the raw key.
 *
 * These labels do not re-render on a language switch — switching reloads the page.
 */
import { getI18nService } from '@infra/i18n';
import type { TranslationKey } from '@infra/i18n';

export function translate(key: TranslationKey, fallback: string): string {
  return getI18nService().t(key, { defaultValue: fallback });
}
